<div class="viw-page" [@esvanecerDesvanecer]="'in'">
  <section class="viw-topbar">
    <div>
      <h1>Venda Interna Whatsapp</h1>
    </div>
    <div class="viw-actions">
      <button class="viw-primary" type="button" (click)="atualizar()">Atualizar</button>
    </div>
  </section>

  <section class="viw-filters">
    <label>
      <span>Vendedora interna</span>
      <select [(ngModel)]="filtro.seller_id" [ngModelOptions]="{standalone: true}">
        <option [ngValue]="null">Todas</option>
        <option *ngFor="let vendedora of dashboard.vendedoras" [ngValue]="vendedora.id">{{ vendedora.nome }}</option>
      </select>
    </label>
    <label>
      <span>Periodo</span>
      <div class="viw-inline">
        <input type="date" [(ngModel)]="filtro.data_inicio" [ngModelOptions]="{standalone: true}" />
        <input [appPeriodoFinal]="filtro.data_inicio" type="date" [(ngModel)]="filtro.data_fim" [ngModelOptions]="{standalone: true}" />
          @if (erroPeriodo) { <small class="text-danger" role="alert">{{ erroPeriodo }}</small> }
      </div>
    </label>
    <label>
      <span>Etapa</span>
      <select [(ngModel)]="filtro.etapa_id" [ngModelOptions]="{standalone: true}">
        <option [ngValue]="null">Todas</option>
        <option *ngFor="let etapa of dashboard.etapas" [ngValue]="etapa.id">{{ etapa.nome }}</option>
      </select>
    </label>
    <label>
      <span>Cliente</span>
      <input type="text" placeholder="Nome, telefone ou ERP" [(ngModel)]="filtro.cliente" [ngModelOptions]="{standalone: true}" />
    </label>
    <button class="viw-primary" type="button" (click)="atualizar()">Filtrar</button>
  </section>

  <section class="viw-kpis">
    <article class="viw-kpi">
      <span>Atendimentos abertos</span>
      <strong>{{ dashboard.atendimentos_abertos | number:'1.0-0' }}</strong>
      <small>Primeiros contatos do periodo</small>
    </article>
    <article class="viw-kpi">
      <span>Em atendimento</span>
      <strong>{{ dashboard.em_atendimento | number:'1.0-0' }}</strong>
      <small class="viw-warn">Atendimentos capturados</small>
    </article>
    <article class="viw-kpi">
      <span>Ganho</span>
      <strong>{{ dashboard.ganho | number:'1.0-0' }}</strong>
      <small class="viw-ok">Atendimentos concluídos</small>
    </article>
    <article class="viw-kpi">
      <span>Perda</span>
      <strong>{{ dashboard.perda | number:'1.0-0' }}</strong>
      <small class="viw-bad">Atendimentos perdidos</small>
    </article>
    <article class="viw-kpi">
      <span>Tempo medio 1 resposta</span>
      <strong>{{ minutos(dashboard.tempo_medio_primeira_resposta_minutos) }}</strong>
      <small>Captura ate primeira acao</small>
    </article>
  </section>

  <section class="viw-grid viw-grid-two">
    <article class="viw-panel">
      <div class="viw-panel-head">
        <div>
          <h2>Funil por etapa x atendimentos</h2>
          <small>Quantidade atual por etapa</small>
        </div>
      </div>
      <div class="viw-funnel">
        <div class="viw-funnel-row" *ngFor="let item of dashboard.funil">
          <b>{{ item.etapa }}</b>
          <div class="viw-track"><span [ngClass]="classeBarraEtapa(item.etapa_tipo)" [style.width.%]="larguraFunil(item)"></span></div>
          <em>{{ item.quantidade | number:'1.0-0' }}</em>
        </div>
      </div>
    </article>

    <article class="viw-panel">
      <div class="viw-panel-head">
        <div>
          <h2>Saude das instancias</h2>
          <small>Clique para abrir vendedores</small>
        </div>
      </div>
      <div class="viw-instance-summary">
        <button type="button" (click)="abrirInstancias('CONECTADAS')" [ngClass]="{ 'viw-instance-summary-active': filtroInstancias == 'CONECTADAS' }">
          <span>Conectadas</span>
          <strong class="viw-ok">{{ dashboard.saude_instancias?.conectadas || 0 }}</strong>
          <small>Instancias prontas</small>
        </button>
        <button type="button" (click)="abrirInstancias('DESCONECTADAS')" [ngClass]="{ 'viw-instance-summary-active': filtroInstancias == 'DESCONECTADAS' }">
          <span>Desconectadas</span>
          <strong class="viw-bad">{{ dashboard.saude_instancias?.desconectadas || 0 }}</strong>
          <small>Necessitam reconectar</small>
        </button>
      </div>
      <div class="viw-instances" *ngIf="filtroInstancias != null">
        <h3>{{ tituloInstanciasFiltradas }}</h3>
        <div class="viw-instance" *ngFor="let instancia of instanciasFiltradas">
          <i class="viw-dot" [ngClass]="instancia.conectada ? 'viw-dot-green' : 'viw-dot-red'"></i>
          <div><b>{{ instancia.vendedor }}</b><small>{{ statusInstancia(instancia) }}</small></div>
          <span class="viw-pill" [ngClass]="instancia.conectada ? 'viw-pill-green' : 'viw-pill-red'">{{ instancia.conectada ? 'Conectada' : 'Desconectada' }}</span>
        </div>
        <div class="viw-empty" *ngIf="instanciasFiltradas.length == 0">Nenhum vendedor encontrado para este status.</div>
      </div>
    </article>
  </section>

  <section class="viw-grid viw-grid-two">
    <article class="viw-panel">
      <div class="viw-panel-head">
        <div>
          <h2>Atendimentos por vendedor interno</h2>
          <small>Volume e tempo medio de captura</small>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-sm viw-table">
          <thead>
            <tr>
              <th>Vendedor interno</th>
              <th class="text-right">Total</th>
              <th class="text-right">Aberto</th>
              <th class="text-right">Em atend.</th>
              <th class="text-right">Ganho</th>
              <th class="text-right">Perda</th>
              <th class="text-right">Captura</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vendedor of dashboard.vendedores">
              <td><b>{{ nomeVendedor(vendedor) }}</b></td>
              <td class="text-right">{{ vendedor.atendimentos | number:'1.0-0' }}</td>
              <td class="text-right">{{ vendedor.aberto | number:'1.0-0' }}</td>
              <td class="text-right">{{ vendedor.atendimento | number:'1.0-0' }}</td>
              <td class="text-right">{{ vendedor.ganho | number:'1.0-0' }}</td>
              <td class="text-right">{{ vendedor.perda | number:'1.0-0' }}</td>
              <td class="text-right">{{ minutos(vendedor.tempo_captura_medio_minutos) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>

    <article class="viw-panel">
      <div class="viw-panel-head">
        <div>
          <h2>Atendimentos feitos x recebidos</h2>
          <small>primeira_mensagem_direcao e resultado</small>
        </div>
      </div>
      <div class="viw-stacked-row" *ngFor="let direcao of dashboard.direcoes">
        <b>{{ rotuloDirecao(direcao.primeira_mensagem_direcao) }}</b>
        <div class="viw-stack">
          <span [style.width.%]="percentual(direcao.aberto, totalDirecao(direcao))"></span>
          <span class="viw-amber" [style.width.%]="percentual(direcao.atendimento, totalDirecao(direcao))"></span>
          <span class="viw-green" [style.width.%]="percentual(direcao.ganho, totalDirecao(direcao))"></span>
          <span class="viw-red" [style.width.%]="percentual(direcao.perda, totalDirecao(direcao))"></span>
        </div>
        <em>{{ totalDirecao(direcao) }}</em>
      </div>
      <div class="viw-legend">
        <span><i></i>Aberto</span>
        <span><i class="viw-amber"></i>Atendimento</span>
        <span><i class="viw-green"></i>Ganho</span>
        <span><i class="viw-red"></i>Perda</span>
      </div>
    </article>
  </section>

  <section class="viw-panel">
    <div class="viw-panel-head">
      <div>
        <h2>Mapa de calor de atendimento por hora</h2>
        <small>Abertura de atendimento por faixa horaria</small>
      </div>
    </div>
    <div class="viw-heatmap">
      <b></b><b *ngFor="let hora of horasMapa">{{ hora }}h</b>
      <ng-container *ngFor="let data of datasMapa">
        <b>{{ rotuloDataMapa(data) }}</b>
        <span *ngFor="let hora of horasMapa" [ngClass]="classeMapa(data.data_atendimento || data.data_atendimento_label, hora)">{{ valorMapa(data.data_atendimento || data.data_atendimento_label, hora) }}</span>
      </ng-container>
    </div>
  </section>

  <section class="viw-panel">
    <div class="viw-panel-head">
      <div>
        <h2>Relatorio dos atendimentos</h2>
        <small>Base operacional para auditoria e drill-down</small>
      </div>
      <button type="button" (click)="exportarAtendimentos()">Exportar</button>
    </div>
    <div class="table-responsive">
      <table class="table table-sm viw-table viw-report">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Telefone</th>
            <th>1a msg</th>
            <th>Data/hr abertura</th>
            <th>Data/hr captura</th>
            <th>Data/hr finalização</th>
            <th>T. atendimento</th>
            <th>T. captura</th>
            <th>Vendedor interno</th>
            <th>Etapa</th>
            <th class="text-right">Msgs</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let atendimento of dashboard.atendimentos; trackBy: trackById">
            <td><b>{{ atendimento.cliente || '' }}</b></td>
            <td><b>{{ atendimento.telefone }}</b></td>
            <td><span class="viw-pill viw-pill-blue">{{ rotuloDirecao(atendimento.primeira_mensagem_direcao) }}</span></td>
            <td>{{ dataHora(atendimento.hr_abertura) }}</td>
            <td>{{ dataHora(atendimento.hr_captura) }}</td>
            <td>{{ dataHora(atendimento.hr_finalizacao) }}</td>
            <td>{{ atendimento.tempo_atendimento_minutos == null ? 'Pendente' : minutos(atendimento.tempo_atendimento_minutos) }}</td>
            <td>{{ atendimento.tempo_captura_minutos == null ? 'Pendente' : minutos(atendimento.tempo_captura_minutos) }}</td>
            <td>{{ atendimento.vendedor_interno || 'Sem responsavel' }}</td>
            <td><span class="viw-pill" [ngClass]="classeEtapa(atendimento.etapa_tipo)">{{ atendimento.etapa }}</span></td>
            <td class="text-right">{{ atendimento.numero_mensagens | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
